import { withAuth } from '@/utilities/queries';
import type { Locale } from '@/utils/locale';
import { getStripeCheckoutUrl } from '@simplywallst/services';
import type { QueryFunctionContext } from '@tanstack/react-query';

export enum CheckoutPlanStatus {
  CANCEL = 'cancel',
  SUCCESS = 'success',
  ERROR = 'error',
}

export async function getStripeCheckoutQuery({
  queryKey: [_key, planId, couponId, planType, planPeriod, locale],
}: QueryFunctionContext<
  [
    string,
    string | undefined,
    string | undefined,
    string | undefined,
    string | undefined,
    Locale,
  ]
>) {
  const path =
    NODE_ENV === 'development' || window.location.href.includes('localhost')
      ? '/plans'
      : window.location.pathname;
  const pathWithDetails = `${path}?checkoutPlanType=${planType}&checkoutPlanPeriod=${planPeriod}`;

  const response = await withAuth(getStripeCheckoutUrl, {
    cancelPath: `${path}?checkoutPlanStatus=${CheckoutPlanStatus.CANCEL}`,
    userReturnPath: encodeURIComponent(
      `${pathWithDetails}&checkoutPlanStatus=${CheckoutPlanStatus.SUCCESS}`
    ),
    userReturnPathError: encodeURIComponent(
      `${pathWithDetails}&checkoutPlanStatus=${CheckoutPlanStatus.ERROR}&checkoutErrorMessage={ERROR_MESSAGE}&checkoutErrorCode={ERROR_CODE}`
    ),
    planId: planId as string,
    couponId,
    locale,
  });
  return response.data;
}
